import { StyleSheet, Text, View } from 'react-native';
import { theme } from '@/constants/theme';

export function ScrollStackItem({ title, body }: { title: string; body: string }) {
  return (
    <View style={s.card}>
      <Text style={s.title}>{title}</Text>
      <Text style={s.body}>{body}</Text>
    </View>
  );
}

export default function ScrollStack({ sections }: { sections: { title: string; body: string }[] }) {
  return <View style={s.wrap}>{sections.map((x, i) => <ScrollStackItem key={i} {...x} />)}</View>;
}

const s = StyleSheet.create({
  wrap: { gap: 10 },
  card: { backgroundColor: '#12172D', borderColor: '#2A315A', borderWidth: 1, borderRadius: 14, padding: 14 },
  title: { color: '#fff', fontFamily: theme.fonts.bold, textAlign: 'right', fontSize: 16 },
  body: { color: '#AEB6D8', fontFamily: theme.fonts.regular, textAlign: 'right', marginTop: 6 },
});
